// extracted by mini-css-extract-plugin
export default {"home":"Home_home__rwouJ","hero":"Home_hero__dSZVV","heroImage":"Home_heroImage__ruVGf","sections":"Home_sections__K+spo"};